import { Box, CircularProgress, Tooltip, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { Color, Size } from 'theme/enums';

interface IProps extends ICellRendererParams {
  loaderEnabled?: boolean;
  error?: string;
}

export const ShipDaysCell = ({ loaderEnabled = false, error, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, 'shipDays');
  if (!data) {
    return <TextLine text={props?.value} />;
  }

  if (loaderEnabled) {
    return (
      <Box>
        <CircularProgress size={Size.SM} />
        <Typography>{data.shipDays}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Tooltip color={Color.DANGER} title={error}>
        <Typography color={Color.DANGER}>
          <Warning />
        </Typography>
      </Tooltip>
    );
  }

  return <TextLine text={data.shipDays || DEFAULT_PLACEHOLDER} />;
};
